import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { LoginForm, RegistrationForm } from '../components/AuthPopup';
import '../components/AuthPopup.css';

/**
 * Standalone login/register PAGE (mobile). Unlike the desktop modal
 * (AuthPopup), this is a real route (/login, /register) so it has its own
 * URL, the browser back button works, and the feed is NOT mounted behind it
 * (React Router renders this instead of the feed on these paths).
 *
 * Reuses the exact same LoginForm / RegistrationForm as the desktop modal,
 * so the auth logic and field names are identical - only the presentation
 * (a page vs. an overlay) differs.
 */
export default function AuthPage({ initialMode = 'login' }) {
  const [mode, setMode] = useState(initialMode);
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsAuthenticated } = useContext(AuthContext);

  // Where to go after a successful login (set by whatever triggered auth).
  const redirectTo = (location.state && location.state.redirectTo) || '/';

  const handleSuccess = () => {
    setIsAuthenticated(true);
    navigate(redirectTo, { replace: true });
  };

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/v1/users/google_oauth`;
  };

  // Back arrow: normal browser history navigation, not a modal close.
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  // Switch between login/register keeps it a real navigation (URL changes),
  // preserving the post-login redirect target.
  const switchMode = (newMode) => {
    setMode(newMode);
    navigate(newMode === 'register' ? '/register' : '/login', {
      replace: true,
      state: { redirectTo },
    });
  };

  return (
    <div className="auth-page">
      <button className="auth-page__back" onClick={handleBack} aria-label="Назад"></button>
      <div className="auth-page__inner">
        <div className="auth-brand">
          <span className="auth-brand__logo">ruben</span>
          <span className="auth-brand__subtitle">Твої улюблені бренди</span>
        </div>
        {mode === 'login' ? (
          <LoginForm onSwitch={switchMode} onSuccess={handleSuccess} handleGoogleLogin={handleGoogleLogin} />
        ) : (
          <RegistrationForm onSwitch={switchMode} onSuccess={handleSuccess} />
        )}
      </div>
    </div>
  );
}
